import { render, staticRenderFns } from "./storeInList.vue?vue&type=template&id=20516d1c&scoped=true"
import script from "./storeInList.vue?vue&type=script&lang=js"
export * from "./storeInList.vue?vue&type=script&lang=js"
import style0 from "./storeInList.vue?vue&type=style&index=0&id=20516d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20516d1c",
  null
  
)

export default component.exports